var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRingingBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71436 17.0357H10.2858",
    stroke: "#253F68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1428 7.39286C14.1428 6.02888 13.601 4.72078 12.6364 3.7563C11.672 2.79184 10.3639 2.25 8.9999 2.25C7.63592 2.25 6.32782 2.79184 5.36334 3.7563C4.39888 4.72078 3.85704 6.02888 3.85704 7.39286V11.8929C3.85704 12.4043 3.65384 12.8949 3.29217 13.2566C2.9305 13.6183 2.43995 13.8214 1.92847 13.8214H16.0713C15.5599 13.8214 15.0692 13.6183 14.7076 13.2566C14.3459 12.8949 14.1428 12.4043 14.1428 11.8929V7.39286Z",
    stroke: "#253F68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.642822 7.22572C0.643515 6.0019 0.935366 4.79581 1.49427 3.70707C2.05317 2.61833 2.86308 1.67819 3.85711 0.964294",
    stroke: "#253F68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3571 7.22572C17.3565 6.0019 17.0646 4.79581 16.5057 3.70707C15.9468 2.61833 15.1368 1.67819 14.1428 0.964294",
    stroke: "#253F68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingingBell);
export default __webpack_public_path__ + "static/media/ringing-bell.1e06d6f196e275ad9da71c1b9c298ee5.svg";
export { ForwardRef as ReactComponent };